import { Box, Spinner, Text } from '@chakra-ui/react';

const FullScreenLoader = () => {
  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      backgroundColor="rgba(255, 255, 255, 0.85)"
      zIndex="9999">
      <Box textAlign="center">
        <Spinner
          size="xl"
          color="teal.500"
          borderWidth="4px"
          emptyColor="gray.200"
          speed="0.8s"
        />
        <Text mt={4} fontSize="lg" color="gray.600">
          로딩 중입니다. 잠시만 기다려 주세요.
        </Text>
      </Box>
    </Box>
  );
};

export default FullScreenLoader;
